import { select } from 'redux-saga/effects';

import { RT } from '../../../shared/types';

import { recordingsModel } from '../../../features/recordings';
import { callModel } from '../../../features/call';
import { JSONContentBuilder } from '@distribute/shared/tiptap/json-content';
import { DEFAULT_RATIO } from '@distribute/shared/utils';

import { CreateOrInsertToPageFlowsEnum } from '../../../features/call/model/types';

export function* createTabContent() {
  const record: RT<typeof recordingsModel.selectors.selectRecord> =
    yield select(recordingsModel.selectors.selectRecord);

  if (Object.keys(record).length > 0) {
    return JSONContentBuilder.videoRecord({
      attrs: {
        prefix: record.prefix,
        playbackId: record.playbackId || '',
        aspectRatio: record.metadata.mux.aspectRatio || DEFAULT_RATIO,
      },
    }).asArray();
  }

  const call: RT<typeof callModel.selectors.selectCurrentCall> = yield select(
    callModel.selectors.selectCurrentCall
  );
  const callPageCreationFlow: RT<
    typeof callModel.selectors.selectPageCreationFlow
  > = yield select(callModel.selectors.selectPageCreationFlow);
  const callSummaryType: RT<
    typeof callModel.selectors.selectCurrentSummaryType
  > = yield select(callModel.selectors.selectCurrentSummaryType);

  if (
    call &&
    callPageCreationFlow !== CreateOrInsertToPageFlowsEnum.PAGE_WITH_AI
  ) {
    const withSummary =
      callPageCreationFlow === CreateOrInsertToPageFlowsEnum.SUMMARY_AND_VIDEO;

    const summary = call.summaries.find(
      (summary) => summary.type === callSummaryType
    );

    const content = JSONContentBuilder.callRecord({
      call: {
        playbackId: call.muxAsset.playback.id,
        aspectRatio: call.muxAsset.data.aspectRatio || DEFAULT_RATIO,
        prefix: call.id,
      },
      summary:
        withSummary && summary
          ? { type: summary.type, data: summary.content }
          : undefined,
    }).asArray();

    return content;
  }

  return [];
}
